import React, { useState } from 'react';
import { Menu, X, ChefHat } from 'lucide-react';
import { scrollToSection } from '../utils/navigation';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <header className="bg-white shadow-lg sticky top-0 z-50">
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between h-16">
          {/* Logo */}
          <div className="flex items-center space-x-2">
            <ChefHat className="h-8 w-8 text-red-600" />
            <div>
              <h1 className="text-xl font-bold text-gray-900">École de la Pizza italienne</h1>
              <p className="text-xs text-gray-600">Formation d'Excellence</p>
            </div>
          </div>

          {/* Navigation Desktop */}
          <nav className="hidden md:flex space-x-8">
            <button 
              onClick={() => scrollToSection('accueil')}
              className="text-gray-700 hover:text-red-600 transition-colors"
            >
              Accueil
            </button>
            <div className="relative group">
              <button 
                onClick={() => scrollToSection('formations')}
                className="text-gray-700 hover:text-red-600 transition-colors"
              >
                Formations
              </button>
              <div className="absolute top-full left-0 mt-2 w-64 bg-white shadow-lg rounded-lg opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-300">
                <div className="py-2">
                  <button 
                    onClick={() => scrollToSection('expert-napolitaine')}
                    className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-red-50 hover:text-red-600"
                  >
                    Expert Pizza Napolitaine
                  </button>
                  <button 
                    onClick={() => scrollToSection('formations')}
                    className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-red-50 hover:text-red-600"
                  >
                    Formation Pizzaïolo
                  </button>
                  <button 
                    onClick={() => scrollToSection('formations')}
                    className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-red-50 hover:text-red-600"
                  >
                    Hygiène Alimentaire
                  </button>
                </div>
              </div>
            </div>
            <button 
              onClick={() => scrollToSection('tarifs')}
              className="text-gray-700 hover:text-red-600 transition-colors"
            >
              Tarifs
            </button>
            <button 
              onClick={() => scrollToSection('contact')}
              className="text-gray-700 hover:text-red-600 transition-colors"
            >
              Contact
            </button>
            <button 
              onClick={() => scrollToSection('inscription')}
              className="bg-red-600 text-white px-4 py-2 rounded-lg hover:bg-red-700 transition-colors"
            >
              S'inscrire
            </button>
          </nav>

          {/* Menu Mobile */}
          <button 
            className="md:hidden"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            {isMenuOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
          </button>
        </div>

        {/* Menu Mobile Dropdown */}
        {isMenuOpen && (
          <div className="md:hidden bg-white border-t">
            <div className="py-4 space-y-2">
              <button 
                onClick={() => {
                  scrollToSection('accueil');
                  setIsMenuOpen(false);
                }}
                className="block w-full text-left px-4 py-2 text-gray-700 hover:bg-red-50"
              >
                Accueil
              </button>
              <button 
                onClick={() => {
                  scrollToSection('expert-napolitaine');
                  setIsMenuOpen(false);
                }}
                className="block w-full text-left px-4 py-2 text-gray-700 hover:bg-red-50"
              >
                Expert Pizza Napolitaine
              </button>
              <button 
                onClick={() => {
                  scrollToSection('formations');
                  setIsMenuOpen(false);
                }}
                className="block w-full text-left px-4 py-2 text-gray-700 hover:bg-red-50"
              >
                Autres Formations
              </button>
              <button 
                onClick={() => {
                  scrollToSection('tarifs');
                  setIsMenuOpen(false);
                }}
                className="block w-full text-left px-4 py-2 text-gray-700 hover:bg-red-50"
              >
                Tarifs
              </button>
              <button 
                onClick={() => {
                  scrollToSection('contact');
                  setIsMenuOpen(false);
                }}
                className="block w-full text-left px-4 py-2 text-gray-700 hover:bg-red-50"
              >
                Contact
              </button>
              <button 
                onClick={() => {
                  scrollToSection('inscription');
                  setIsMenuOpen(false);
                }}
                className="block w-full text-left px-4 py-2 bg-red-600 text-white rounded-lg mx-4"
              >
                S'inscrire
              </button>
            </div>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;